<!-- 微信公众号的登录回调页 -->
<template>
  <!-- 空登陆页 -->
  <view />
</template>

<script>
  import officialAccount from '@/platform/provider/wechat/officialAccount'

  export default {
    name: 'Login',
    async created() {
      const {code = ''} = this.$route.query
      await officialAccount.login(code);

      let returnUrl = localStorage.getItem('returnUrl');
      if (returnUrl) {
        localStorage.removeItem('returnUrl');
        location.replace(returnUrl);
      } else {
        location.href = '/';
      }
    }
  };
</script>
